export default "__VITE_ASSET__f398U_GNpmcYtwxxT94vqQ__"